import { render, staticRenderFns } from "./DownloadIdComponent.vue?vue&type=template&id=0ba6c708&scoped=true"
import script from "./DownloadIdComponent.vue?vue&type=script&lang=js"
export * from "./DownloadIdComponent.vue?vue&type=script&lang=js"
import style0 from "./DownloadIdComponent.vue?vue&type=style&index=0&id=0ba6c708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba6c708",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
